import { version } from '../../package.json';
export default version;


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/_antd@3.1.4@antd/es/version/index.js
// module id = null
// module chunks = 